import DefaultStrideIcon from './DefaultStrideIcon';
import Invoice from './Invoice';
import TransOrderManagement from './TransOrderManagement';
import ShadowMode from './ShadowMode';
import Profile from './Profile';
import Releases from './Releases';
import Requests from './Requests';
import TripManagement from './TripManagement';
import { Resources, DownloadCenter } from './Resources/index';
import {
    Carrier_Truck,
    Driver,
    Location_Location,
    Route_Lane,
    Supplier_Supplier,
    Trailer_Equipment,
    Zone_Cold,
    MDM,
    MDM_Setup,
} from './MDM/index';
import { Configuration, LoadAndTrip, Query, Create } from './Trip_Load/index';
import Finance from './Finance/Finance';
import { LoadBuilder, ManualLoadPlanning, WTMSStrideSync } from './LoadBuilder/index';

// Please Add icon name in list below
const StrideIconList = [
    'default',
    'Carrier_Truck',
    'Driver',
    'Location_Location',
    'Route_Lane',
    'Supplier_Supplier',
    'Trailer_Equipment',
    'Zone_Cold',
    'MDM',
    'MDM_Setup',
    'Configuration',
    'LoadAndTrip',
    'Query',
    'Create',
    'Invoice',
    'Finance',
    'LoadBuilder',
    'ShadowMode',
    'Profile',
    'ManualLoadPlanning',
    'Releases',
    'Requests',
    'TripManagement',
    'TransOrderManagement',
];

export {
    DefaultStrideIcon,
    Carrier_Truck,
    Driver,
    Location_Location,
    Route_Lane,
    Supplier_Supplier,
    Trailer_Equipment,
    Zone_Cold,
    MDM,
    Configuration,
    LoadAndTrip,
    Query,
    Create,
    Invoice,
    MDM_Setup,
    Finance,
    LoadBuilder,
    ShadowMode,
    Profile,
    ManualLoadPlanning,
    Releases,
    Requests,
    TripManagement,
    TransOrderManagement,
    WTMSStrideSync,
    Resources,
    DownloadCenter,
    StrideIconList,
};
